import { render, staticRenderFns } from "./GeneralSettingContactAddressCountry.vue?vue&type=template&id=6a2883c9&"
import script from "./GeneralSettingContactAddressCountry.vue?vue&type=script&lang=ts&"
export * from "./GeneralSettingContactAddressCountry.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports